import { useState, useEffect } from 'react';

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-6 right-6 z-40 w-10 h-10 flex items-center justify-center rounded-full bg-[oklch(var(--primary-500))] text-[oklch(var(--background-50))] shadow-lg hover:bg-[oklch(var(--primary-600))] transition-all cursor-pointer"
      aria-label="返回顶部"
    >
      <i className="ri-arrow-up-line text-lg" />
    </button>
  );
}